// src/views/AddStockOut.js
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import ProjectService from "../services/ProjectService";
import ProjectStoreService from "../services/ProjectStoreService";
import ItemsService from "../services/ItemsServices";
import ProjectLocationService from "../services/ProjectLocationService";
import StockOutService from "../services/StockOutService";
import StorageService from "../services/StorageService";
import StockIndentService from "../services/stockIndentService";
import TransporterService from "../services/TransporterService";
import ProjectItemService from "../services/ProjectItemService";
import Select from "react-select";
import ProjectTeamService from "../services/ProjectTeamService";
import Loading from "../components/loading";
import MessageDialog from "../components/MessageDialog";

export default function AddStockOut() {
  const { id } = useParams(); // id for edit
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [projectLocations, setProjectLocations] = useState([]);
  const [items, setItems] = useState([]);
  const inputRefs = useRef([]);
  const [transporters, setTransporters] = useState([]);
  const [stockItems, setStockItems] = useState([
    {
      itemCategoryId: "",
      itemId: "",
      itemDescription: "",
      uomId: "",
      quantity: "",
      availableQty: 0,
      siteBalance: "0.000",
    },
  ]);



  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [projectEmployees, setProjectEmployees] = useState([]);

  const [messageType, setMessageType] = useState("error"); // error | success

  const companyId = StorageService.activeCompany()?.companyId ?? null;
  const employeeId = StorageService.loginData()?.employeeId ?? "System";

  useEffect(() => {
    if (!warningMessage) return;
    const timer = setTimeout(() => {
      setWarningMessage("");
    }, 7000);
    return () => clearTimeout(timer);
  }, [warningMessage]);

  const [projectFullData, setProjectFullData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState({});

  const today = new Date().toISOString().split("T")[0];
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange", reValidateMode: "onChange",
    defaultValues: {
      transactionDate: today,
    },
  });

  const storeIdValue = watch("storeId");

  const selectedStore = stores.find((s) => String(s.storeId ?? s.id) === String(storeIdValue));
  const storeName = selectedStore ? selectedStore.storeName || selectedStore.name || "" : "";

  const getFilteredCategories = () => {
    return categories;
  };

  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS BY COMPANY
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     }
  //     //  NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       console.log("Projects dropdown data:", projects);
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };

  const loadProjectEmployees = async (projectId, targetDate = null, currentReceiver = null) => {
    if (!projectId) {
      setProjectEmployees([]);
      return;
    }

    try {
      const txnDate = targetDate || getValues("transactionDate") || null;
      const res = await ProjectTeamService.getByProjectId(projectId, false, txnDate);

      const seen = new Set();
      const mapped = [];

      (res || []).forEach((e) => {
        const empId = e.employeeId;
        const fullName = `${e.firstName || ""} ${e.lastName || ""}`.trim();
        const key = empId ? String(empId) : fullName;
        if (key && !seen.has(key)) {
          seen.add(key);
          mapped.push({
            id: empId,
            name: fullName,
          });
        }
      });

      const selectedReceiver = currentReceiver ?? getValues("receiverName");
      if (selectedReceiver && !mapped.some((m) => m.name === selectedReceiver)) {
        mapped.unshift({
          id: `preserved-${selectedReceiver}`,
          name: selectedReceiver,
        });
      }

      setProjectEmployees(mapped);
    } catch (err) {
      console.error("Project employees load error", err);
      setProjectEmployees([]);
    }
  };

  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN & DATA ADMIN → ALL PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };



  const loadProjectFullData = async (projectId) => {
    try {
      const res = await ProjectItemService.getProjectFullData(projectId);
      const data = res?.data?.data || [];

      setProjectFullData(data);
      setCategories(data);

      return data;   // ⭐ IMPORTANT
    } catch (err) {
      console.error("Category load error", err);
      setProjectFullData([]);
      setCategories([]);
      return [];
    }
  };

  const handleCategoryChange = (index, categoryId) => {
    const updated = [...stockItems];
    updated[index].itemCategoryId = categoryId;
    updated[index].itemId = "";
    updated[index].itemDescription = "";
    updated[index].uomId = "";
    updated[index].availableQty = 0;
    setStockItems(updated);
  };


  const getItemOptions = (categoryId) => {
    const cat = projectFullData.find(
      (c) => String(c.itemCategoryId) === String(categoryId)
    );

    if (!cat) return [];

    return cat.items.map((i) => ({
      value: i.itemId,
      label: i.itemCode,
    }));
  };



  const loadStores = async (projectId) => {
    if (!projectId) {
      setStores([]);
      return;
    }
    try {
      const res = await ProjectStoreService.getProjectStoreById(projectId);
      const list = res.data || res || [];
      setStores(
        list.filter((s) => String(s.projectId) === String(projectId))
      );
    } catch (err) {
      console.error("Store load error", err);
      setStores([]);
    }
  };

  const loadTransporters = async () => {
    try {
      // dropdown should always load first page
      const res = await TransporterService.getActiveTransporters(1, 100);

      const list = res?.data || [];
      setTransporters(list);
    } catch (err) {
      console.error("Transporter load error:", err);
      setTransporters([]);
    }
  };


  const loadItemsByProject = async (projectId) => {
    if (!projectId) {
      setItems([]);
      return;
    }

    try {
      const res = await ProjectItemService.getByProjectId(projectId);
      const list = res?.data?.data || [];

      const mapped = list.map((x) => ({
        id: x.itemId,
        itemId: x.itemId,
        itemName: x.itemCode,
        itemDescription: x.itemDescription,
        uomName: x.uomName,
      }));

      setItems(mapped);
    } catch (err) {
      console.error("Project item load error", err);
      setItems([]);
    }
  };





  const loadProjectLocations = async (projectId, storeId) => {
    if (!projectId || !storeId) {
      setProjectLocations([]);
      setValue("projectLocationId", "");
      return;
    }

    try {
      const res = await ProjectLocationService.getByProjectAndStore(
        projectId,
        storeId
      );

      setProjectLocations(res?.data || []);
    } catch (err) {
      console.error("Location load error", err);
      setProjectLocations([]);
    }
  };


  const fetchVoucherNo = async (projectId, storeId) => {
    if (!projectId || !storeId) return;

    try {
      const res = await StockOutService.previewVoucherNo(projectId, storeId);

      setValue(
        "voucherNo",
        res?.data?.voucherNo || ""
      );
    } catch (err) {
      console.error("StockOut voucher fetch error", err);
      setValue("voucherNo", "");
    }
  };


  const fetchAvailableQuantity = async (projectId, storeId, itemId) => {
    const companyId = StorageService.activeCompany()?.companyId;

    if (!companyId || !projectId || !storeId || !itemId) return 0;

    try {
      const res = await StockIndentService.getAvailableStock(
        companyId,
        projectId,
        storeId,
        itemId
      );

      return res?.data?.result?.quantity ?? 0;
    } catch (err) {
      console.error("Available qty fetch error", err);
      return 0;
    }
  };


  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await loadProjects();
      await loadTransporters();

      if (isEdit) await loadForEdit(id);
      setLoading(false);
    };

    init();

    return () => {
      // if (messageTimer.current) clearTimeout(messageTimer.current);
    };
  }, [id]);

  // Auto-select dropdowns if only 1 option is available
  useEffect(() => {
    if (projects.length === 1 && !isEdit) {
      const singleProj = projects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      setValue("projectId", pId);

      // Inline Project onChange logic:
      setItems([]);
      setStockItems([
        { itemId: "", itemDescription: "", uomId: "", quantity: "", availableQty: 0 }
      ]);
      loadStores(pId);
      setProjectLocations([]);
      setValue("projectLocationId", "");
      loadItemsByProject(pId);
      loadProjectFullData(pId);
      loadProjectEmployees(pId, getValues("transactionDate"));
    }
  }, [projects, isEdit]);

  useEffect(() => {
    const filteredStores = stores.filter((s) => {
      const code = (s.storeCode || "").trim().toLowerCase();
      return !code.startsWith("scrap");
    });
    if (filteredStores.length === 1 && !isEdit) {
      const singleStore = filteredStores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      setValue("storeId", sId);

      // Inline Store onChange logic:
      const pid = getValues("projectId");
      setProjectLocations([]);
      setValue("projectLocationId", "");
      if (pid && sId) {
        fetchVoucherNo(pid, sId);
        loadProjectLocations(pid, sId);
      }
    }
  }, [stores, isEdit]);

  useEffect(() => {
    if (projectLocations.length === 1 && !isEdit) {
      const singleLoc = projectLocations[0];
      const locId = String(singleLoc.id);
      setValue("projectLocationId", locId);
      updateAllSiteBalances(locId);
    }
  }, [projectLocations, isEdit]);

  useEffect(() => {
    if (transporters.length === 1 && !isEdit) {
      const singleTrans = transporters[0];
      const tId = String(singleTrans.id ?? singleTrans.transporterId);
      setValue("transporterId", tId);
    }
  }, [transporters, isEdit]);



  // const showMessage = (txt, type = "error") => {
  //   setMessage(txt);
  //   setMessageType(type);

  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => {
  //     setMessage("");
  //     setMessageType("error");
  //   }, 4000);
  // };


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMessageType(type);
  };

  const findCategoryId = (itemId) => {
    const category = projectFullData.find(c =>
      c.items.some(i => String(i.itemId) === String(itemId))
    );

    return category ? String(category.itemCategoryId) : "";
  };


  const loadForEdit = async (editId) => {
    try {

      const res = await StockOutService.getById(editId);
      const stockOut = res?.data?.data;

      const formattedTxnDate = stockOut.transactionDate
        ? stockOut.transactionDate.split("T")[0]
        : "";

      setValue("projectId", String(stockOut.projectId ?? ""));
      setValue("transactionDate", formattedTxnDate);
      setValue("receiverName", stockOut.receiverName ?? "");

      await loadProjectEmployees(stockOut.projectId, formattedTxnDate, stockOut.receiverName);
      // await loadProjectFullData(stockOut.projectId);
      const projectData = await loadProjectFullData(stockOut.projectId);
      await loadItemsByProject(stockOut.projectId);
      await loadStores(stockOut.projectId);
      await loadProjectLocations(stockOut.projectId, stockOut.storeId);

      setValue("storeId", String(stockOut.storeId ?? ""));
      setValue("projectLocationId", String(stockOut.projectLocationId ?? ""));
      setValue("voucherNo", stockOut.vocherNo ?? "");
      setValue("transporterId", String(stockOut.transporterId ?? ""));
      setValue("vehicleNo", stockOut.vehicleNo ?? "");
      setValue("stockOutNotes", stockOut.stockOutNotes ?? "");

      // setStockItems(
      //   stockOut.details?.length
      //     ? stockOut.details.map((d) => ({
      //       itemCategoryId: findCategoryId(d.itemId),
      //       itemId: String(d.itemId ?? ""),
      //       itemDescription: d.itemName ?? "",
      //       uomId: d.UOM ?? "",
      //       quantity: String(d.quantity ?? ""),
      //       availableQty: 0, // will load when item changes
      //       detailId: d.detailId
      //     }))
      //     : [{
      //       itemCategoryId: "",
      //       itemId: "",
      //       itemDescription: "",
      //       uomId: "",
      //       quantity: "",
      //       availableQty: 0
      //     }]
      // );
      const mappedItems = stockOut.details?.length
        ? stockOut.details.map((d) => {

          const category = projectData.find(cat =>
            cat.items?.some(i => String(i.itemId) === String(d.itemId))
          );

          return {
            itemCategoryId: category ? String(category.itemCategoryId) : "",
            itemId: String(d.itemId ?? ""),
            itemDescription: d.itemCode ?? "", // use itemCode instead of itemName
            uomId: d.UOM ?? "",
            quantity: String(d.quantity ?? ""),
            availableQty: 0,
            detailId: d.detailId
          };

        })
        : [{
          itemCategoryId: "",
          itemId: "",
          itemDescription: "",
          uomId: "",
          quantity: "",
          availableQty: 0,
          siteBalance: "0.000"
        }];

      setStockItems(mappedItems);
      stockOut.details.forEach(async (d, index) => {
        try {
          const qty = await fetchAvailableQuantity(
            stockOut.projectId,
            stockOut.storeId,
            d.itemId
          );

          let siteBalance = 0;
          if (stockOut.projectLocationId) {
            const balanceRes = await StockOutService.getSiteBalance(stockOut.projectLocationId, d.itemId);
            siteBalance = balanceRes?.data?.siteBalance ?? 0;
          }

          setStockItems(prev => {
            const copy = [...prev];
            if (copy[index]) {
              const num = Number(qty);
              copy[index].availableQty = !isNaN(num)
                ? (num % 1 === 0 ? num.toFixed(3) : String(qty))
                : "0.000";
              copy[index].siteBalance = Number(siteBalance).toFixed(3);
            }
            return copy;
          });
        } catch (err) {
          console.error("Error loading quantities for edit row:", err);
        }
      });


    } catch (err) {
      console.error("Edit load error", err);
      showMessage("Failed to load data for modify", "error");
    }
  };



  // const loadForEdit = async (editId) => {
  //   try {
  //     const res = await StockOutService.getById(editId);

  //     const stockOut = res?.data?.data;
  //     if (!stockOut) return;

  //     // Header fields
  //     setValue("projectId", String(stockOut.projectId ?? ""));
  //     await loadStores(stockOut.projectId);
  //     await loadProjectLocations(stockOut.projectId);

  //     setValue("storeId", String(stockOut.storeId ?? ""));
  //     setValue("projectLocationId", String(stockOut.projectLocationId ?? ""));
  //     setValue("voucherNo", stockOut.vocherNo ?? "");
  //     setValue("transporterId", String(stockOut.transporterId ?? ""));
  //     setValue("transactionDate", stockOut.transactionDate ?? "");
  //     setValue("receiverName", stockOut.receiverName ?? "");
  //     setValue("stockOutNotes", stockOut.stockOutNotes ?? "");

  //     // ✅ DETAILS (DIRECT FROM BACKEND)
  //     setStockItems(
  //       stockOut.details?.length
  //         ? stockOut.details.map((d) => ({
  //           itemId: String(d.itemId ?? ""),
  //           uomId: d.UOM ?? "",
  //           quantity: String(d.quantity ?? ""),
  //           detailId: d.detailId,
  //         }))
  //         : [{ itemId: "", uomId: "", quantity: "" }]
  //     );
  //   } catch (err) {
  //     console.error("Edit load error", err);
  //     showMessage("Failed to load data for modify", "error");
  //   }
  // };


  const updateAllSiteBalances = async (locationId) => {
    if (!locationId) {
      setStockItems(prev => prev.map(row => ({ ...row, siteBalance: "0.000" })));
      return;
    }

    const updatedItems = await Promise.all(
      stockItems.map(async (row) => {
        if (row.itemId) {
          try {
            const res = await StockOutService.getSiteBalance(locationId, row.itemId);
            const balance = res?.data?.siteBalance ?? 0;
            return {
              ...row,
              siteBalance: Number(balance).toFixed(3)
            };
          } catch (err) {
            console.error("Site balance fetch error:", err);
            return { ...row, siteBalance: "0.000" };
          }
        }
        return { ...row, siteBalance: "0.000" };
      })
    );

    setStockItems(updatedItems);
  };

  const handleAddRow = () =>
    setStockItems([...stockItems, {
      itemCategoryId: "",
      itemId: "",
      itemDescription: "",
      uomId: "",
      quantity: "",
      availableQty: 0,
      siteBalance: "0.000",
    },
    ]);

  const hasDuplicateStockOutItems = () => {
    const selectedItemIds = stockItems
      .map((r) => String(r.itemId).trim())
      .filter(Boolean);
    return selectedItemIds.length !== new Set(selectedItemIds).size;
  };

  const handleDeleteRow = (idx) => {
    const copy = [...stockItems];
    copy.splice(idx, 1);
    setStockItems(copy);
  };

  // const handleChange = async (idx, field, value) => {
  //   const copy = [...stockItems];

  //   // quantity validation
  //   if (field === "quantity") {
  //     const reqQty = Number(value);
  //     const availQty = Number(copy[idx].availableQty);

  //     // ADD THIS (important)
  //     if (isNaN(reqQty)) {
  //       return;
  //     }

  //     if (reqQty <= 0) {
  //       showMessage("Request Quantity must be greater than 0", "error");
  //       return;
  //     }

  //     if (reqQty > availQty) {
  //       showMessage(
  //         `Requested quantity (${reqQty}) is greater than available quantity (${availQty})`,
  //         "error"
  //       );
  //       return;
  //     }
  //   }


  //   copy[idx][field] = value;

  //   if (field === "itemId") {
  //     const selectedItem = items.find(
  //       (it) => String(it.id) === String(value)
  //     );

  //     copy[idx].uomId = selectedItem?.uomName || "";
  //     copy[idx].itemDescription = selectedItem?.itemDescription || "";

  //     const availQty = await fetchAvailableQuantity(
  //       getValues("projectId"),
  //       getValues("storeId"),
  //       value
  //     );

  //     copy[idx].availableQty = availQty;
  //     copy[idx].quantity = ""; // reset quantity when item changes
  //   }

  //   setStockItems(copy);
  // };

  const handleChange = async (idx, field, value) => {
    if (
      field === "itemId" &&
      value &&
      stockItems.some(
        (row, rowIndex) => rowIndex !== idx && String(row.itemId) === String(value)
      )
    ) {
      showMessage("This item is already selected in another row.", "error");
      return;
    }

    const copy = [...stockItems];

    if (field === "quantity") {
      const reqQty = Number(value);
      const availQty = Number(copy[idx].availableQty);

      if (isNaN(reqQty)) return;
      if (reqQty <= 0) {
        showMessage("Request Quantity must be greater than 0", "error");
        return;
      }
      if (reqQty > availQty) {
        showMessage(
          `Requested quantity (${reqQty}) is greater than available quantity (${availQty})`,
          "error"
        );
        return;
      }
    }

    copy[idx][field] = value;

    if (field === "itemId") {
      const selectedItem =
        items.find((it) => String(it.id) === String(value)) ||
        items.find((it) => String(it.itemId) === String(value));

      copy[idx].uomId = selectedItem?.uomName || "";
      copy[idx].itemDescription = selectedItem?.itemDescription || "";

      const availQty = await fetchAvailableQuantity(
        getValues("projectId"),
        getValues("storeId"),
        value
      );

      copy[idx].availableQty = availQty;
      copy[idx].quantity = "";

      const locId = getValues("projectLocationId");
      if (locId && value) {
        try {
          const res = await StockOutService.getSiteBalance(locId, value);
          const balance = res?.data?.siteBalance ?? 0;
          copy[idx].siteBalance = Number(balance).toFixed(3);
        } catch (err) {
          console.error("Error fetching site balance:", err);
          copy[idx].siteBalance = "0.000";
        }
      } else {
        copy[idx].siteBalance = "0.000";
      }
    }

    setStockItems(copy);
  };


  const handleQuantityChange = (index, e) => {
    let value = e.target.value;

    // allow only numbers + decimal with at most 3 decimal places
    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    setStockItems(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        quantity: value
      };
      return updated;
    });
  };

  const handleQuantityBlur = (index) => {
    setStockItems(prev => {
      const updated = [...prev];
      const val = updated[index].quantity;
      if (val !== "" && !isNaN(Number(val))) {
        updated[index].quantity = Number(val).toFixed(3);
      }
      return updated;
    });
  };

  const onSubmit = async (form) => {
    // validate at least one detail row has item + qty
    if (!stockItems || stockItems.length === 0) {
      showMessage("Add at least one item row", "error");
      return;
    }
    const bad = stockItems.some((r) => !r.itemId || !r.uomId || !r.quantity);
    if (bad) {
      showMessage("All detail rows must have Item, UOM and Quantity", "error");
      return;
    }

    const duplicateItemIds = stockItems
      .map((r) => String(r.itemId).trim())
      .filter(Boolean);

    if (duplicateItemIds.length !== new Set(duplicateItemIds).size) {
      showMessage("Duplicate items are not allowed in Stock Out details.", "error");
      return;
    }

    const today = new Date().toLocaleDateString("en-CA");

    // if (form.transactionDate > today) {
    //   showMessage("Transaction Date cannot be a future date", "error");
    //   return;
    // }

    if (form.transactionDate > today) {
      showMessage("Transaction Date cannot be a future date", "error");
      return;
    }

    const qtyError = stockItems.some(
      (r) => Number(r.quantity) > Number(r.availableQty)
    );

    if (qtyError) {
      showMessage(
        "Available quantity less than requested quantity for that item",
        "error"
      );
      return;
    }

    const invalidQty = stockItems.some(
      (r) => Number(r.quantity) <= 0
    );

    if (invalidQty) {
      showMessage(
        "Request Quantity must be greater than 0 for all items",
        "error"
      );
      return;
    }


    // if (txnDate > today) {
    //   showMessage("Transaction Date cannot be a future date", "error");
    //   return;
    // }


    setLoading(true);
    try {
      const details = stockItems.map((r) => ({
        itemId: Number(r.itemId),
        UOM: r.uomId,
        quantity: Number(r.quantity),
        status: "Active",
        createdBy: employeeId,
        createdDate: new Date().toISOString(),
        updatedBy: employeeId,
        updatedDate: new Date().toISOString(),
      }));

      const payload = {
        companyId,
        storeId: Number(form.storeId),
        projectId: Number(form.projectId),
        projectLocationId: Number(form.projectLocationId),
        vocherNo: form.voucherNo,
        transporterId: Number(form.transporterId),
        // vehicleNo: form.vehicleNo,
        vehicleNo: form.vehicleNo ? form.vehicleNo.trim() : null,
        transactionDate: form.transactionDate,
        receiverName: form.receiverName,
        stockOutNotes: form.stockOutNotes,
        status: "pending",
        roleId: Number(StorageService.loginData()?.roleId),
        createdBy: employeeId,
        updatedBy: employeeId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),

        // ✅ MUST MATCH BACKEND
        stockOutDetails: details,
      };

      let warningMsg = null;
      if (isEdit) {
        // update header
        const res = await StockOutService.update(id, payload);
        warningMsg = res?.data?.warning || res?.warning || res?.data?.data?.warning;
        if (warningMsg) {
          setWarningMessage(warningMsg);
        } else {
          showMessage("Stock Out updated successfully", "success");
        }
      } else {
        const res = await StockOutService.save(payload);
        warningMsg = res?.data?.warning || res?.warning || res?.data?.data?.warning;
        console.log("create response", res, "warning:", warningMsg);
        if (warningMsg) {
          setWarningMessage(warningMsg);
        } else {
          showMessage("Stock Out saved successfully", "success");
        }
      }

      const redirectDelay = warningMsg ? 7000 : 600;
      setTimeout(() => navigate("/cpnl/stockout/view"), redirectDelay);
    } catch (err) {
      console.error("Save error", err);
      const msg = err?.response?.data?.message || "Error saving Stock Out";
      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Stock Out" : "Add Stock Out"}
        secondTitle="Inventory"
      />

      <div className="card p-4 bg-white shadow-sm">
        {loading ? (
          <div className="text-center py-5">
            <Loading />
          </div>
        ) : (
          <>
            {/* {message && (
              <div
                className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"
                  } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
                style={{ borderRadius: "5px" }}
              >
                <span>{message}</span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMessage("")}
                  style={{ fontSize: "0.8rem" }}
                />
              </div>
            )} */}

            <MessageDialog
              message={message}
              type={messageType}
              setMessage={setMessage}
              setMsgType={setMessageType}
            />

            {warningMessage && (
              <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content border-0 shadow">
                    <div className="modal-header bg-warning text-dark">
                      <h5 className="modal-title font-weight-bold">
                        <i className="ti ti-alert-triangle me-2"></i>Warning
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setWarningMessage("")}
                      ></button>
                    </div>
                    <div className="modal-body p-4">
                      <p className="mb-0 text-dark font-weight-medium">{warningMessage}</p>
                    </div>
                    <div className="modal-footer bg-light">
                      <button
                        type="button"
                        className="btn btn-warning text-dark font-weight-bold"
                        onClick={() => setWarningMessage("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                <div className="mb-3 col-md-4">
                  <label className="form-label">Project<span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    {...register("projectId", { required: "Project is required" })}
                    onChange={(e) => {
                      const pid = e.target.value;

                      setValue("projectId", pid);
                      setValue("storeId", "");
                      setValue("voucherNo", "");
                      setValue("receiverName", "");   // clear receiver
                      setItems([]);                 // clear old items
                      setStockItems([
                        { itemId: "", itemDescription: "", uomId: "", quantity: "", availableQty: 0 }
                      ]);

                      loadStores(pid);
                      // loadProjectLocations(pid);
                      setProjectLocations([]);
                      setValue("projectLocationId", "");
                      loadItemsByProject(pid);
                      loadProjectFullData(pid);
                      loadProjectEmployees(pid, getValues("transactionDate"));  // load employees
                    }}

                  >

                    <option value="">Select Project</option>
                    {/* {projects.map((p) => (
                  <option key={p.id ?? p.projectId} value={p.id ?? p.projectId}>
                    {p.projectName || p.name}
                  </option>
                ))} */}

                    {projects.map((p) => (
                      <option key={p.projectId} value={p.projectId}>
                        {p.projectCategoryName ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}` : (p.projectCode ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}` : p.projectName)}
                      </option>
                    ))}

                  </select>
                </div>

                <div className="mb-3 col-md-4">
                  <label className="form-label">
                    From Store <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("storeId", { required: "From Store is required" })}
                    onChange={(e) => {
                      const sid = e.target.value;
                      setValue("storeId", sid);

                      const pid = getValues("projectId");

                      // 🔥 CLEAR OLD LOCATION & RESET ITEMS
                      setProjectLocations([]);
                      setValue("projectLocationId", "");
                      setStockItems([
                        {
                          itemCategoryId: "",
                          itemId: "",
                          itemDescription: "",
                          uomId: "",
                          quantity: "",
                          availableQty: 0,
                          siteBalance: "0.000",
                        },
                      ]);

                      if (pid && sid) {
                        fetchVoucherNo(pid, sid);
                        loadProjectLocations(pid, sid);   // 🔥🔥🔥 LOAD BY STORE
                      }
                    }}
                  >

                    <option value="">Select From Store</option>
                    {stores
                      .filter((s) => {
                        const code = (s.storeCode || "").trim().toLowerCase();
                        return !code.startsWith("scrap");
                      })
                      .map((s) => (
                        <option key={s.id ?? s.storeId} value={s.storeId ?? s.id}>
                          {s.storeName || s.name}
                        </option>
                      ))}
                  </select>
                  {errors.storeId && (
                    <small className="text-danger">{errors.storeId.message}</small>
                  )}
                </div>

                <div className="mb-3 col-md-4">
                  <label className="form-label">
                    To Location <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("projectLocationId", {
                      required: "To Location is required",
                      onChange: async (e) => {
                        const locId = e.target.value;
                        setValue("projectLocationId", locId);
                        await updateAllSiteBalances(locId);
                      }
                    })}
                    disabled={!getValues("storeId")}
                  >
                    <option value="">Select To Location</option>
                    {projectLocations.map((l) => (
                      <option key={l.id} value={l.id}>
                        {l.locationName}
                      </option>
                    ))}
                  </select>
                  {errors.projectLocationId && (
                    <small className="text-danger">{errors.projectLocationId.message}</small>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-md-4">
                  <label className="form-label">Voucher No</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("voucherNo")}
                    readOnly
                  />
                </div>

                {/* TRANSPORTER */}
                <div className="mb-3 col-md-4">
                  <label className="form-label">
                    Transporter
                  </label>
                  <select
                    className="form-select"
                    {...register("transporterId", {
                    })}
                  >
                    <option value="">Select Transporter</option>
                    {transporters.map((t) => (
                      <option
                        key={t.id ?? t.transporterId}
                        value={t.id ?? t.transporterId}
                      >
                        {t.transporterName || t.name}
                      </option>
                    ))}
                  </select>
                  {errors.transporterId && (
                    <small className="text-danger">
                      {errors.transporterId.message}
                    </small>
                  )}
                </div>


                <div className="mb-3 col-md-4">
                  <label className="form-label">
                    Vehicle No
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Vehicle No (TS09AB1234)"
                    {...register("vehicleNo", {
                      // required: "Vehicle No is required",
                      // validate: (value) => {
                      //   if (!value) return true;

                      //   const regex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{4}$/;
                      //   return regex.test(value.toUpperCase()) || "Invalid Vehicle No (TS09AB1234)";
                      // },
                      onChange: (e) => {
                        e.target.value = e.target.value.toUpperCase(); // 🔥 auto uppercase
                      }
                    })}
                  />

                  {errors.vehicleNo && (
                    <small className="text-danger">{errors.vehicleNo.message}</small>
                  )}
                </div>
              </div>


              <div className="row">
                {/* TRANSACTION DATE */}
                <div className="mb-3 col-md-4">
                  <label className="form-label">
                    Transaction Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    max={today}
                    {...register("transactionDate", {
                      required: "Transaction Date is required",
                      onChange: (e) => {
                        const newDate = e.target.value;
                        const pid = getValues("projectId");
                        if (pid) {
                          loadProjectEmployees(pid, newDate);
                        }
                      },
                      validate: (value) => {
                        if (!value) return true;

                        // Compare ONLY date part (no timezone)
                        const selected = value; // yyyy-mm-dd
                        const today = new Date().toLocaleDateString("en-CA"); // yyyy-mm-dd

                        if (selected > today) {
                          return "Transaction Date cannot be a future date";
                        }

                        const emp = StorageService.loginData();
                        const isPrivileged =
                          emp?.roleName === "Super Admin" ||
                          emp?.roleName === "SuperAdmin" ||
                          emp?.roleName === "Data Admin" ||
                          emp?.roleName === "DataAdmin" ||
                          Number(emp?.roleId) === 1 ||
                          Number(emp?.roleId) === 2;

                        if (!isPrivileged && selected < today) {
                          return "Only Super Admin and Data Admin can select a past date";
                        }

                        return true;
                      },
                    })}
                  />
                  {errors.transactionDate && (
                    <small className="text-danger">
                      {errors.transactionDate.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">
                    Receiver Name
                  </label>
                  {/* <input
                type="text"
                className="form-control"
                placeholder="Enter receiver name"
                {...register("receiverName", {
                })}
              /> */}
                  <select
                    className="form-select"
                    {...register("receiverName")}
                  >
                    <option value="">Select Receiver</option>

                    {projectEmployees.map((emp) => (
                      <option key={emp.id} value={emp.name}>
                        {emp.name}
                      </option>
                    ))}
                  </select>
                  {errors.receiverName && (
                    <small className="text-danger">
                      {errors.receiverName.message}
                    </small>
                  )}
                </div>



                <div className="col-md-4 mb-3">
                  <label className="form-label">Notes</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter notes"
                    {...register("stockOutNotes")}
                  />
                </div>
              </div>


              <hr />
              <h5>Stock Out Details</h5>

              <div className="table-responsive mt-2" style={{ overflowX: "auto", ...(stockItems.length >= 4 ? { maxHeight: "280px", overflowY: "auto" } : {}) }}>
                <table className="table table-bordered mb-0" style={{ minWidth: "1500px" }}>
                  <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                    <tr>
                      <th style={{ minWidth: "290px" }}>Item Category</th>
                      <th style={{ minWidth: "370px" }}>Item</th>
                      <th style={{ minWidth: "280px" }}>Item Description</th>
                      <th style={{ minWidth: "100px" }}>UOM</th>
                      <th style={{ minWidth: "130px" }}>Avalible Qty</th>
                      <th style={{ minWidth: "130px" }}>Site Balance</th>
                      <th style={{ minWidth: "130px" }}>Quantity</th>
                      <th style={{ minWidth: "80px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stockItems.map((row, idx) => (
                      <tr key={idx}>

                        <td>
                          {/* <select
                      className="form-select"
                      value={row.itemCategoryId}
                      onChange={(e) =>
                        handleCategoryChange(idx, e.target.value)
                      }
                    >
                      <option value="">Select Category</option>
                      {categories.map((c) => (
                        <option key={c.itemCategoryId} value={c.itemCategoryId}>
                          {c.itemCategoryName}
                        </option>
                      ))}
                    </select> */}

                          <Select
                            value={
                              categories
                                .map((c) => ({
                                  value: c.itemCategoryId,
                                  label: c.itemCategoryName,
                                }))
                                .find((opt) => String(opt.value) === String(row.itemCategoryId)) || null
                            }
                            onChange={(selected) =>
                              handleCategoryChange(idx, selected ? selected.value : "")
                            }
                            options={getFilteredCategories().map((c) => ({
                              value: c.itemCategoryId,
                              label: c.itemCategoryName,
                            }))}
                            placeholder="Search Category..."
                            isClearable
                            menuPlacement="auto"
                            maxMenuHeight={150}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />

                        </td>
                        <td>
                          {/* <Select
                      value={
                        getItemOptions(row.itemCategoryId).find(
                          (o) => String(o.value) === String(row.itemId)
                        ) || null
                      }
                      onChange={(selected) =>
                        handleChange(idx, "itemId", selected ? selected.value : "")
                      }
                      options={getItemOptions(row.itemCategoryId)}
                      placeholder="Type at least 2 letters..."
                      isDisabled={!row.itemCategoryId}
                      isClearable

                      components={{ DropdownIndicator: null, IndicatorSeparator: null }}

                      onInputChange={(input) => {
                        setSearchText(prev => ({ ...prev, [idx]: input }));
                      }}

                      menuIsOpen={(searchText[idx] || "").length >= 2}
                    /> */}

                          <Select
                            value={
                              getItemOptions(row.itemCategoryId).find(
                                (o) => String(o.value) === String(row.itemId)
                              ) || null
                            }
                            onChange={(selected) =>
                              handleChange(idx, "itemId", selected ? selected.value : "")
                            }
                            options={getItemOptions(row.itemCategoryId)}
                            placeholder="Search Item..."
                            isDisabled={!row.itemCategoryId}
                            isClearable

                            // UI improvements
                            menuPlacement="auto"
                            maxMenuHeight={150}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}

                            // optional: remove arrow
                            components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                          />

                        </td>

                        <td>
                          <input
                            className="form-control fw-bold text-dark"
                            value={row.itemDescription}
                            readOnly
                          />
                        </td>

                        <td>
                          <input
                            className="form-control fw-bold text-dark"
                            value={row.uomId}
                            readOnly
                          />
                        </td>

                        <td>
                          {/* <input
                          className="form-control fw-bold text-dark"
                          value={row.availableQty}
                          readOnly
                        /> */}

                          <input
                            className="form-control fw-bold text-dark text-end"
                            value={Number(row.availableQty || 0).toFixed(3)}
                            readOnly
                          />
                        </td>

                        <td>
                          <input
                            className="form-control fw-bold text-dark text-end"
                            value={Number(row.siteBalance || 0).toFixed(3)}
                            readOnly
                          />
                        </td>

                        <td>
                          {/* <input
                          type="number"
                          className="form-control fw-bold text-dark"
                          value={row.quantity}
                          onChange={(e) =>
                            handleChange(idx, "quantity", e.target.value)
                          }
                        /> */}

                          <input
                            type="text"
                            className="form-control fw-bold text-dark text-end"
                            value={row.quantity ?? ""}
                            onChange={(e) => handleQuantityChange(idx, e)}
                            onBlur={() => handleQuantityBlur(idx)}
                            placeholder="Quantity"
                          />
                        </td>


                        <td className="text-center">
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={handleAddRow}
                          >
                            +
                          </button>
                          {stockItems.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteRow(idx)}
                            >
                              -
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? isEdit
                      ? "Updating..."
                      : "Saving..."
                    : isEdit
                      ? "Update"
                      : "Save"}
                </button>



                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/cpnl/stockout/view")}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );
}
